import { ComponentKey } from 'enums/componentKey';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { LegalEntityFormValues } from 'features/new-actor/types/optim/legalEntityFormValues';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from '../addressInputsConfig';
import { baseLegalEntityInputsConfig } from '../baseLegalEntityInputsConfig';
import { contactInputsConfig } from '../contactInputsConfig';

export const legalEntityInputsConfig: InputsConfig<Exclude<keyof LegalEntityFormValues, 'id'>> =
{
  ...contactInputsConfig,
  ...addressInputsConfig,
  ...baseLegalEntityInputsConfig,
  // Autocomplete de l'annuaire des entreprises : la sélection remplit SIRET et adresse.
  [LegalEntityFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.CompanySearch,
    name: LegalEntityFormFieldNames.CompanyName,
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.COMPANY_NAME'
  },
  [PersonalInformationFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.Phone,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.PHONE'
  },
  [PersonalInformationFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.Email,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.EMAIL'
  },

  // Rendered by hand in LegalEntityLayout (UpiContactSection).
  [LegalEntityFormFieldNames.Contacts]: {
    componentKey: ComponentKey.Custom,
    name: LegalEntityFormFieldNames.Contacts,
  },

  // Rendered by hand in LegalEntityLayout, only when the financials block is enabled.
  [LegalEntityFormFieldNames.Financials]: {
    componentKey: ComponentKey.Custom,
    name: LegalEntityFormFieldNames.Financials,
  },
};
